/**
 * Google Analytics Event Constants
 * Based on GA Tracking Plan - Sheet 2
 * 
 * Usage example:
 * import { trackEvent } from '../services/gaTracking';
 * import { GA_EVENTS } from '../constants/gaEvents';
 * 
 * // Track an event
 * trackEvent(GA_EVENTS.LOGIN, {
 *   "User Name": userDetails.name,
 *   "Business Module": userDetails.businessModule,
 *   "Location": userDetails.location,
 *   "Last logged in": userDetails.lastLogin
 * });
 */

export const GA_EVENTS = {
  // Login Page
  LOGIN: {
    event: "Login",
    eventCategory: "Login Page",
    eventAction: "Login",
    eventLabel: "Login",
  },

  // Home Page
  HOME_SCREEN_VIEW: {
    event: "Home Screen",
    eventCategory: "Home Page",
    eventAction: "Home Screen",
    eventLabel: "Home Screen",
  },

  LOGOUT: {
    event: "Logout",
    eventCategory: "Home Page",
    eventAction: "Logout",
    eventLabel: "Logout",
  },

  NOTIFICATION_CLICK: {
    event: "Notification Click",
    eventCategory: "Home Page",
    eventAction: "Notification Click",
    eventLabel: "Notification Click",
  },

  MY_PROFILE_CLICK: {
    event: "My profile Click",
    eventCategory: "Home Page",
    eventAction: "My profile Click",
    eventLabel: "My profile Click",
  },

  QUICK_ASSIST_CLICK: {
    event: "Quick Assist Click",
    eventCategory: "Home Page",
    eventAction: "Quick Assist Click",
    eventLabel: "Quick Assist Click",
  },

  SUBMIT_TICKET_CLICK: {
    event: "Submit Ticket Click",
    eventCategory: "Home Page",
    eventAction: "Submit Ticket Click",
    eventLabel: "Submit Ticket Click",
  },

  CRITICAL_OVERDUE_CLOSE_NOW_CLICK: {
    event: "Critical Overdue close now click",
    eventCategory: "Home Page",
    eventAction: "Critical Overdue close now click",
    eventLabel: "Critical Overdue close now click",
  },

  PENDING_TASKS_CLOSE_NOW_CLICK: {
    event: "Pending tasks close now click",
    eventCategory: "Home Page",
    eventAction: "Pending tasks close now click",
    eventLabel: "Pending tasks close now click",
  },

  // Dashboard
  SALES_CLICK: {
    event: "Sales click",
    eventCategory: "Dashboard",
    eventAction: "Sales click",
    eventLabel: "Sales click",
  },

  DISCOUNT_CLICK: {
    event: "Discount Click",
    eventCategory: "Dashboard",
    eventAction: "Discount Click",
    eventLabel: "Discount Click",
  },

  DELIVER_CLICK: {
    event: "Deliver Click",
    eventCategory: "Dashboard",
    eventAction: "Deliver Click",
    eventLabel: "Deliver Click",
  },

  INSTALLATION_CLICK: {
    event: "Installation Click",
    eventCategory: "Dashboard",
    eventAction: "Installation Click",
    eventLabel: "Installation Click",
  },

  INSTOCK_CLICK: {
    event: "Instock Click",
    eventCategory: "Dashboard",
    eventAction: "Instock Click",
    eventLabel: "Instock Click",
  },

  // Activity Tracker
  SEL_CLICK: {
    event: "SEL Click",
    eventCategory: "Activity Tracker",
    eventAction: "SEL Click",
    eventLabel: "SEL Click",
  },

  PLANO_CLICK: {
    event: "PLANO Click",
    eventCategory: "Activity Tracker",
    eventAction: "PLANO Click",
    eventLabel: "PLANO Click",
  },

  GRN_CLICK: {
    event: "GRN Click",
    eventCategory: "Activity Tracker",
    eventAction: "GRN Click",
    eventLabel: "GRN Click",
  },

  GRDC_CLICK: {
    event: "GRDC Click",
    eventCategory: "Activity Tracker",
    eventAction: "GRDC Click",
    eventLabel: "GRDC Click",
  },

  AUTO_PI_CLICK: {
    event: "Auto PI Click",
    eventCategory: "Activity Tracker",
    eventAction: "Auto PI Click",
    eventLabel: "Auto PI Click",
  },

  AD_HOC_CLICK: {
    event: "Ad-Hoc Click",
    eventCategory: "Activity Tracker",
    eventAction: "Ad-Hoc Click",
    eventLabel: "Ad-Hoc Click",
  },

  // Quick Assist
  RESOLVED_CLICK: {
    event: "Resolved click",
    eventCategory: "Quick Assist",
    eventAction: "Resolved click",
    eventLabel: "Resolved click",
  },

  PENDING_CLICK: {
    event: "Pending click",
    eventCategory: "Quick Assist",
    eventAction: "Pending click",
    eventLabel: "Pending click",
  },

  // Store Communications

    LEAD_MANAGEMENT_CLICK: {
    event: "Lead Management Click",
    eventCategory: "Lead Management",
    eventAction: "Lead Management Click",
    eventLabel: "Lead Management Click",
  },
  LEAD_CLICK:{
    event: "Lead Click",
    eventCategory: "Lead Management",
    eventAction: "Lead Click",
    eventLabel: "Lead Click",
  },

  // App Stability
  ERROR_BOUNDARY: {
    event: "Error Boundary",
    eventCategory: "App Stability",
    eventAction: "Component Crash",
    eventLabel: "Error Boundary",
  }
};

